import { render, staticRenderFns } from "./revisar-avance-partidas-info.vue?vue&type=template&id=12a48fb5&scoped=true&"
import script from "./revisar-avance-partidas-info.vue?vue&type=script&lang=js&"
export * from "./revisar-avance-partidas-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a48fb5",
  null
  
)

export default component.exports